export enum BatchType {
  PLANS_AND_RATES = 'PLANS_AND_RATES',
  SERVICE_AREAS = 'SERVICE_AREAS',
  PLAN_BENEFITS = 'PLAN_BENEFITS',
  SMOKER_RATES = 'SMOKER_RATES',
}
